










































import Vue from 'vue'
export default Vue.extend({
    props: {
        //  Determines if we are view only and hiding buttons
        viewOnly: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        hostingColumns: [
            {
                title: '1. Submit the form',
                description:
                    "Provide the phone number, billing address under current provider, and phone provider's name"
            },
            {
                title: '2. Wait for hosting',
                description:
                    'Wait 1-2 business days. Our Numbers Team will reach out directly with a timeline'
            },
            {
                title: '3. Use your phone number',
                description:
                    'Send and receive texts with MessageDesk. Make and receive calls with your existing phone provider'
            }
        ]
    })
})
